<template>
  <b-form-checkbox-group class="row">
    <div class="col-md-12" v-for="(notification, i) in notifications" :key="i">
      <!-- Single Notification -->
      <label class="notification" :value="notification.name">
        <div class="toggler" :class="[notification.value ? 'bg' : '']">
          <div class="slider" :class="[notification.value ? 'btns' : '']"></div>
        </div>
        <div class="notification-content">
          <h6>{{ notification.name }}</h6>
          <p>
            {{ notification.text }}
          </p>
        </div>
        <input
          type="checkbox"
          class="invisible"
          @change="changed"
          v-model="notification.value"
        />
      </label>
      <!-- Single Notification -->
    </div>
  </b-form-checkbox-group>
</template>

<script>
export default {
  props: ["list"],
  data() {
    return {
      notifications: this.list
    };
  },
  methods: {
    changed() {
      this.$emit("settingsUpdated", this.notifications);
    }
  }
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;

  .notification-content {
    margin-left: 14px;
    cursor: pointer;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;

      color: #8d99a0;
      margin: 0;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;

      display: flex;
      align-items: center;
      color: #474d52;
      @media (max-width: 874px) {
        margin-bottom: 0px;
      }
    }
  }
  .toggler {
    @media (max-width: 874px) {
      margin-bottom: 10px;
      margin-left: 15px;
    }
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
</style>
